import { render, staticRenderFns } from "./TheNetworkIDTNumberAddForm.vue?vue&type=template&id=5fef986a&"
import script from "./TheNetworkIDTNumberAddForm.vue?vue&type=script&lang=js&"
export * from "./TheNetworkIDTNumberAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports